import { useDocumentTitle } from "usehooks-ts";
import { DataTableContextProvider } from "../DataTable/DataTableContext";
import { DataTable } from "../DataTable/DataTable";

export const AllLearnersPage: React.FC = () => {
  useDocumentTitle("All Learners Beta");
  return (
    <DataTableContextProvider
      source="/manager_new/parent-portal/learners-beta"
      defaults={{
        sortBy: [{ id: "subscriptionTrialStartedAt", desc: true }],
        pageSize: 250,
      }}
      sortable={[
        "first",
        "last",
        "email",
        "login_count",
        "last_action",
        "recentCourse",
        "pointsEarned",
        "pointsUsed",
        "sectionsCompleted",
        "unitsCompleted",
        "subscriptionTrialStartedAt",
        "statusAndDate.endDate",
        "last_login",
        "total_app_time",
        "interval",
        "cost",
        "parentEmail",
        "totalQuestionsAnswered",
        "totalQuestionsCorrect",
        "status",
        "endDate",
        "trialLength",
      ]}
      filterable={[
        "first",
        "last",
        "email",
        "status",
        "recentCourse",
        "parentEmail",
      ]}
      globalFilter
      fetchOnLoad
    >
      <AllLearnersContent />
    </DataTableContextProvider>
  );
};

const AllLearnersContent: React.FC = () => {
  return (
    <div className="flex flex-col gap-8 p-6">
      <h1 className="text-2xl font-bold">All Learners (Beta)</h1>
      <DataTable />
    </div>
  );
};
